module.exports = __webpack_public_path__ + "img/1f_r_moriyama@2x.7d3ec48a.jpg";